<div class="header">
    <img [src]="ImgEnum.BANNER | imageSrc" alt="brand-logo">
</div>
<div class="content-container">
    <div class="smart-assistant-content">
        <app-free-trial></app-free-trial>
        <app-setup-account></app-setup-account>
        <app-test-call></app-test-call>
        <app-get-in-contact></app-get-in-contact>
    </div>
</div>

